/***************************************************************
7/19/2017
Alexander Self
Profile Container
- Edits user profiles
***************************************************************/
import { mapEmployeeForAutoComplete, findEmployeeByName } from '../../../utils';
import { AutoComplete } from '../../inputs';
import EmployeeList from '../../employee_list';
import ProfileEditForm from './profile_edit_form';
import { fetchProfileToEdit, submitProfileToEdit, submitLoginToEdit,
   fetchPostionType } from '../../../actions/profile_actions';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class ProfileEdit extends Component {
  componentDidMount() {
    if (this.props.positionTypes.length === 0) this.props.fetchPostionType();
  }
  render() {
    return (
      <div className="row">
        <blockquote><span className="flow-text">Profile Edit</span></blockquote>
        <div className="col s12 m12 l2">
          <AutoComplete id={'employee-profile-list'} label={'Find Employee'}
            data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={(val) => this.props.fetchProfileToEdit(findEmployeeByName(val, this.props.employees), this.props.employees)} />
          <div className="emp-list">
            <div className="card">
              <EmployeeList employees={this.props.employees} icon={'mode_edit'} header={'View Employee'} _class={'blue'}
                onClick={(e) => this.props.fetchProfileToEdit(e, this.props.employees)} isEditOrDelete={true}
              />
            </div>
          </div>
        </div>
        <div className="col s12 m12 l10">
          <ProfileEditForm employees={this.props.employees}
            submitProfileToEdit={this.props.submitProfileToEdit}
            submitLoginToEdit={this.props.submitLoginToEdit}
            positionTypes={this.props.positionTypes}
            employee={this.props.employee}
          />
        </div>

      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    employees: state.profile.employees,
    positionTypes: state.misc.positionTypes,
    employee: state.profile.edit.employee
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchProfileToEdit,
    submitProfileToEdit,
    submitLoginToEdit,
    fetchPostionType
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);



/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/edit/profile_edit.js